import {
    FC,
    Fragment,
    ReactNode,
    useEffect,
    useRef,
    UIEvent,
    useMemo,
    useState,
} from "react";
import { uuid } from "utils";
interface AppScrollProps {
    id?: string;
    ref?: React.RefObject<HTMLDivElement | null>;
    children?: ReactNode;
    className?: string;
    onLoadMore?: () => void;
    onScroll?: React.UIEventHandler<HTMLDivElement>
}

interface PositionInfoProps {
    dragStart: number;
    dragStartScroll: number;
    readyScroll: boolean;
}
const AppScroll: FC<AppScrollProps> = ({ id, ref, children, className, onLoadMore, onScroll }) => {
    const [uid] = useState(uuid());
    const containerRef = useRef<HTMLDivElement>(null);
    const xRef = useRef<HTMLDivElement>(null);
    const yRef = useRef<HTMLDivElement>(null);

    const y = useRef<PositionInfoProps>({
        dragStart: 0,
        dragStartScroll: 0,
        readyScroll: false
    });
    const x = useRef<PositionInfoProps>({
        dragStart: 0,
        dragStartScroll: 0,
        readyScroll: false
    });

    const handleScroll = (e: UIEvent<HTMLDivElement>) => {
        onScroll && onScroll(e);
        const target = e.currentTarget;
        const { scrollTop, scrollHeight, clientHeight } = target;
        // Kiểm tra nếu user cuộn gần cuối (ví dụ còn <100px thì gọi loadMore)
        if (scrollHeight - scrollTop - clientHeight < 100) {
            onLoadMore?.();
        }
    };

    const divRef = useMemo(() => {
        return ref || containerRef
    }, [ref, containerRef])

    useEffect(() => {
        if (!divRef.current) return;


        const updatePosition = () => {
            if (!divRef.current) return;
            const el = divRef.current!;

            const isYHidden = getComputedStyle(el!).overflowY === "hidden";
            const isXHidden = getComputedStyle(el!).overflowX === "hidden";
            // Khai báo scroll y
            const scrollHeight = el.scrollHeight;
            const clientHeight = el.clientHeight;
            const scrollTop = el.scrollTop;
            const thumbHeight = clientHeight * clientHeight / scrollHeight;
            const thumbTop = scrollTop * clientHeight / scrollHeight;

            // Khai báo scroll x
            const scrollWidth = el.scrollWidth;
            const clientWidth = el.clientWidth;
            const scrollLeft = el.scrollLeft;
            const thumbWidth = clientWidth * clientWidth / scrollWidth;
            const thumbLeft = scrollLeft * clientWidth / scrollWidth;

            // Tính scroll y
            if (yRef.current) {
                yRef.current.style.left = `${scrollLeft + clientWidth - 8}px`;
                if (scrollHeight > clientHeight && !isYHidden) {
                    yRef.current.style.height = `${thumbHeight}px`;
                    yRef.current.style.top = `${thumbTop + scrollTop}px`;
                }
                else {
                    yRef.current.style.height = "0px";
                    yRef.current.style.top = `0px`;
                }

            }

            // Tính scroll x
            if (xRef.current) {
                xRef.current.style.top = `${scrollTop + clientHeight - 8}px`;
                if (scrollWidth > clientWidth && !isXHidden) {
                    xRef.current.style.width = `${thumbWidth}px`;
                    xRef.current.style.left = `${thumbLeft + scrollLeft}px`;
                }
                else {
                    xRef.current.style.width = "0px";
                    xRef.current.style.left = `0px`;
                }
            }
        };

        const resizeObserver = new ResizeObserver(updatePosition);
        resizeObserver.observe(divRef.current);

        // mutationObserver để theo dõi khi div bị di chuyển trong DOM
        const mutationObserver = new MutationObserver(updatePosition);
        mutationObserver.observe(document.body, { childList: true, subtree: true });

        // lắng nghe divRef scroll 
        divRef.current.addEventListener("scroll", updatePosition, true);

        updatePosition();

        return () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            divRef.current?.removeEventListener("scroll", updatePosition, true);
        };
    }, []);

    useEffect(() => {
        const el = divRef.current;

        const mouseMove = (e: MouseEvent) => {
            if (!el) return;

            if (y.current.readyScroll && yRef.current) {
                const { scrollHeight, clientHeight } = el;

                const scrollRatio = scrollHeight / clientHeight; // tỉ lệ scrollbar
                const deltaY = e.clientY - y.current.dragStart;

                el.scrollTop = y.current.dragStartScroll + deltaY * scrollRatio;
                yRef.current.classList.add("opacity-60", "w-[10px]", "ml-[-5px]");

            }

            // ===== Scroll X =====
            if (x.current.readyScroll && xRef.current) {
                const { scrollWidth, clientWidth } = el;

                const scrollRatio = scrollWidth / clientWidth;
                const deltaX = e.clientX - x.current.dragStart;

                el.scrollLeft = x.current.dragStartScroll + deltaX * scrollRatio;
                xRef.current.classList.add("opacity-60", "h-[10px]", "mt-[-5px]");
            }
        };

        const mouseUp = () => {
            y.current.readyScroll = false;
            x.current.readyScroll = false;
            document.body.classList.remove("select-none");
            yRef.current?.classList.remove("opacity-60", "w-[10px]", "ml-[-5px]");
            xRef.current?.classList.remove("opacity-60", "h-[10px]", "mt-[-5px]");
            divRef.current!.style.pointerEvents = "auto";
        };

        document.addEventListener("mousemove", mouseMove);
        document.addEventListener("mouseup", mouseUp);

        return () => {
            document.removeEventListener("mousemove", mouseMove);
            document.removeEventListener("mouseup", mouseUp);
        };
    }, [])

    return (
        <Fragment>
            <div
                id={id}
                ref={divRef}
                onScroll={handleScroll}
                // className={`relative overflow-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden group/${uid} ${className}`}
                className={`relative overflow-auto  group/${uid} ${className}`}
            >
                {/* <div
                    ref={yRef}
                    className={`absolute bg-gray-500 opacity-0 group-hover/${uid}:opacity-60 transition-opacity transition-width duration-200 rounded w-[5px] cursor-pointer z-[51] hover:w-[10px] hover:ml-[-5px]`}
                    onMouseDown={(e) => {
                        document.body.classList.add("select-none");
                        y.current = {
                            dragStart: e.clientY,
                            dragStartScroll: divRef.current!.scrollTop || 0,
                            readyScroll: true
                        };
                        divRef.current!.style.pointerEvents = "none";
                        yRef.current?.classList.add("opacity-60", "w-[10px]", "ml-[-5px]");
                    }}
                />
                <div
                    ref={xRef}
                    className={`absolute bg-gray-500 opacity-0 group-hover/${uid}:opacity-60 transition-opacity transition-height duration-200 rounded h-[5px] cursor-pointer z-[51] hover:h-[10px] hover:mt-[-5px]`}
                    onMouseDown={(e) => {
                        document.body.classList.add("select-none");
                        x.current = {
                            readyScroll: true,
                            dragStart: e.clientX,
                            dragStartScroll: divRef.current!.scrollLeft || 0
                        }
                        divRef.current!.style.pointerEvents = "none";
                        xRef.current?.classList.add("opacity-60", "h-[10px]", "mt-[-5px]");
                    }}
                /> */}
                {children}
            </div>
        </Fragment >
    );
};

export default AppScroll;
